import {
  breakpointSizes,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import { grey450 } from 'ext-ui/style/colors'
import React from 'react'
import { css, CSSProp } from 'styled-components'

interface BoxProps {
  id?: string
  testId?: string
  className?: string
  onClick?: () => void
  noPadding?: boolean
  noShadow?: boolean
  orgBookkeeper?: boolean
  topBox?: boolean
  bottomBox?: boolean
  isHighlighted?: boolean
  refObj?: React.RefObject<HTMLDivElement>
  padding?: string
  outlineBorder?: boolean
  css?: CSSProp
  'data-testid'?: string
}

const Box: React.FC<React.PropsWithChildren<BoxProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      id={props?.id}
      data-testid={props?.testId || props?.['data-testid']}
      className={props.className}
      {...(props.onClick
        ? {
            onClick: props.onClick,
            onKeyPress: props.onClick,
            role: 'button',
            tabIndex: 0,
          }
        : {})}
      ref={props.refObj}
      css={css`
        background-color: ${styleConstants.colors.white};
        border-radius: ${styleConstants.borderRadius.box};
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);

        padding: ${props.padding ||
        `${styleConstants.heights.cardPadding} ${styleConstants.widths.cardPaddingXSMUp}`};
        ${getBreakpointOnly(breakpointSizes.XXSM)(css`
          padding: ${props.padding ||
          `${styleConstants.heights.cardPadding} ${styleConstants.widths.cardPaddingXXSMOnly}`};
        `)}

        ${!!props.noPadding &&
        css`
          padding: 0px;
        `}

        ${props.outlineBorder &&
        css`
          border: 1px solid ${grey450};
        `}

        ${!!props.noShadow &&
        css`
          box-shadow: none;
        `}

        ${!!props.orgBookkeeper &&
        css`
          margin-top: 0px !important;
          border-top: 1px solid #f6f7fb;
        `}

        ${!!props.topBox &&
        css`
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        `}

        ${!!props.bottomBox &&
        css`
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        `}

        ${!!props.isHighlighted &&
        css`
          border: 3px solid ${styleConstants.colors.purple};
        `}

        ${props.css && props.css}
      `}
    >
      {props.children}
    </div>
  )
}

export default Box
